import { render } from "./generalreport.vue?vue&type=template&id=63baf035"
import script from "./generalreport.vue?vue&type=script&lang=js"
export * from "./generalreport.vue?vue&type=script&lang=js"

import "./generalreport.vue?vue&type=style&index=0&id=63baf035&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__